<template>
  <v-layout>
    <v-main>
      <v-container>
        <slot></slot>
      </v-container>
    </v-main>
  </v-layout>
</template>

<style>
html,
body {
  background: #f5f8fa;
  min-height: 100%;
}
</style>
